import { makeAutoObservable } from 'mobx'

class CacheStore {
  constructor() {
    makeAutoObservable(this)
  }

  private dataMap: Map<string, unknown> = new Map()
  setData = <T>(key: string, data: T) => {
    this.dataMap.set(key, data)
  }
  getData = <T>(key: string): T | undefined => {
    return this.dataMap.get(key) as T
  }
}

export const cacheStore = new CacheStore()
